module.exports = __webpack_public_path__ + "static/img/case-dd-page-bg-04.d2b6381.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/dd/case-dd-page-bg-04.jpg
// module id = enob
// module chunks = 1